import React from 'react';

import styled from '@emotion/styled';

export const Spacer = styled.div<{ height?: string; width?: string; inline?: boolean }>`
  ${(props) => props.inline && 'display: inline-block;'}
  height: ${(props) => (props.height ? props.height : 'initial')};
  width: ${(props) => (props.width ? props.width : 'initial')};
`;
